import React from "react";

// This should NOT be used as a hack to inject arbitrary content.
// (Obviously, it's still possible, but this makes it a bit harder.)
const STYLE = {
  display: "none"
};

class InjectedTenantScripts extends React.Component {
  _update() {
    let { content } = this.props;

    if (!content || !content.__html || !this.container) {
      return;
    }

    // Ref: https://github.com/christo-pr/dangerously-set-html-content/blob/master/src/index.js
    let slotHtml = document
      .createRange()
      .createContextualFragment(content.__html);
    this.container.innerHTML = "";
    this.container.appendChild(slotHtml);
  }

  componentDidMount() {
    this._update();
  }

  render() {
    let { content } = this.props;

    if (!content || !content.__html) {
      return null;
    }

    return (
      <div
        className="Eventive--TenantScripts"
        style={STYLE}
        ref={r => {
          this.container = r;
        }}
      />
    );
  }
}

export default InjectedTenantScripts;



// WEBPACK FOOTER //
// ./src/app/components/partials/injected-tenant-scripts.jsx